<template>
  <div id="manual-providing" class="s-base">
    <v-card class="s-panel mx-auto" max-width="1000">
      <v-card-title class="s-title">マニュアル提供画面</v-card-title>
      <v-card class="mx-auto" max-width="80%">
        <v-list class="mx-auto">
          <v-list-item
            v-for="(manual, i) in manuals"
            :key="i"
            :href="manual.url"
            link
            target="_blank"
          >
            <v-list-item-icon>
              <v-icon v-text="manual.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="manual.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <div class="d-flex flex-row px-3 pt-6 pb-3">
        <v-btn color="primary" x-large @click="clickReturn()">戻る</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script lang="ts">
import loginModule from "../store/LoginModule";
import { Component, Vue } from "vue-property-decorator";
import { userApi } from "@/api/UserApi";
import { NETWORK_ERROR } from "@/router";

@Component({})
export default class ManualProviding extends Vue {
  manuals = [
    {
      text: "契約者操作画面－操作マニュアル",
      icon: "mdi-folder",
      url: "/manual/user.pdf",
    },
    {
      text: "リアルタイム配信－クライアントアプリ操作マニュアル",
      icon: "mdi-folder",
      url: "/manual/client.pdf",
    },
    {
      text: "一括配信－ダウンロードマニュアル",
      icon: "mdi-folder",
      url: "/manual/bulk.pdf",
    },
    {
      text: "準リアルタイム配信－ダウンロードマニュアル",
      icon: "mdi-folder",
      url: "/manual/sem_real.pdf",
    },
  ];

  clickReturn() {
    this.$router.push({ name: "Menu" });
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
</style>
